import { type ForwardedRef, forwardRef } from 'react';
import { IMaskMixin } from 'react-imask';

import Input, { type IInputProps } from '../input';

export interface CurrencyInputProps extends Omit<
  IInputProps,
  'value' | 'onChange'
> {
  value?: number | string | null;
  onChange?: (value: number | null) => void;
  inputRef?: ForwardedRef<HTMLInputElement>;
}

const CurrencyInputComponent = IMaskMixin<HTMLInputElement, any>(
  ({ inputRef, ...props }) => {
    return <Input ref={inputRef} {...props} />;
  }
);

const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ value, onChange, ...props }, forwardedRef) => {
    return (
      <CurrencyInputComponent
        inputRef={forwardedRef}
        mask={Number}
        scale={0}
        thousandsSeparator=" "
        padFractionalZeros={false}
        normalizeZeros={true}
        radix="."
        mapToRadix={[',']}
        unmask={true}
        value={value ? String(value) : ''}
        onAccept={(unmaskedValue: string) => {
          if (onChange) {
            onChange(unmaskedValue ? Number(unmaskedValue) : null);
          }
        }}
        {...props}
      />
    );
  }
);

CurrencyInput.displayName = 'CurrencyInput';

export default CurrencyInput;
